<template>
  <div class="progress-tracker">
    <div class="pt-header">
      <div class="pt-title">Tiến trình theo dõi</div>
      <div class="pt-subtitle">{{ completedCount }}/{{ totalWeeks }} tuần</div>
    </div>
    <div class="pt-list">
      <div
        v-for="week in weekItems"
        :key="week.weekNumber"
        class="pt-item"
        :class="{ active: selectedWeek === week.weekNumber }"
        @click="$emit('select', week.weekNumber)"
      >
        <div class="pt-item__label">Tuần {{ week.weekNumber }}</div>
        <span class="pt-item__badge" :class="week.isCompleted ? 'badge-done' : 'badge-pending'">
          {{ week.isCompleted ? 'Hoàn thành' : 'Chưa xong' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressTracker',
  props: {
    weekList: {
      type: Array,
      default: () => [],
    },
    selectedWeek: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    totalWeeks() {
      return this.weekList.filter((w) => w.weekNumber > 0).length;
    },
    weekItems() {
      const map = {};
      this.weekList.forEach((w) => {
        map[w.weekNumber] = w;
      });
      return Array.from({ length: this.totalWeeks }, (_, i) => ({
        weekNumber: i + 1,
        isCompleted: map[i + 1] ? !!map[i + 1].isCompleted : false,
      }));
    },
    completedCount() {
      return this.weekList.filter((w) => w.weekNumber > 0 && w.isCompleted).length;
    },
  },
};
</script>

<style scoped>
.progress-tracker {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 16px;
  max-height: 80vh;
  overflow-y: auto;
}
.pt-header {
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
}
.pt-title {
  font-weight: 600;
  font-size: 14px;
  color: #111827;
}
.pt-subtitle {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}
.pt-list {
  padding: 8px 0;
}
.pt-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  cursor: pointer;
  border-left: 3px solid transparent;
  transition: background 0.15s;
}
.pt-item:hover {
  background: #f9fafb;
}
.pt-item.active {
  background: #eef6ff;
  border-left-color: #3b82f6;
}
.pt-item__label {
  font-size: 13px;
  color: #374151;
}
.pt-item__badge {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 10px;
}
.badge-done {
  background: #d1fae5;
  color: #065f46;
}
.badge-pending {
  background: #f3f4f6;
  color: #6b7280;
}
</style>
